import { render, staticRenderFns } from "./scheduler-class.vue?vue&type=template&id=520ce532"
import script from "./scheduler-class.vue?vue&type=script&lang=ts"
export * from "./scheduler-class.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports